export default "__VITE_ASSET__cS8kyJWY__"